/**
 * @generated SignedSource<<b47141a2cd14c8ba8582a1fd3ba72d94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type runSubmissionValidationQuery$variables = {
  id: string;
};
export type runSubmissionValidationQuery$data = {
  readonly _sys_validation_property_batch_async: {
    readonly errors: any | null;
    readonly output: {
      readonly ok: boolean;
    } | null;
  } | null;
};
export type runSubmissionValidationQuery = {
  response: runSubmissionValidationQuery$data;
  variables: runSubmissionValidationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "_sys_validation_property_batch_async",
    "kind": "LinkedField",
    "name": "_sys_validation_property_batch_async",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "validation_property_batch_output",
        "kind": "LinkedField",
        "name": "output",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ok",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "runSubmissionValidationQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "runSubmissionValidationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c20621f36cb56a5f0ebbebae60c5471f",
    "id": null,
    "metadata": {},
    "name": "runSubmissionValidationQuery",
    "operationKind": "query",
    "text": "query runSubmissionValidationQuery(\n  $id: uuid!\n) {\n  _sys_validation_property_batch_async(id: $id) {\n    output {\n      ok\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1266a6913db3e8cba6cc984778ae1b2";

export default node;
